export default "__VITE_ASSET__5NTr6cc6NRqYy5jNE$FD$A__"